import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, message, Result, Skeleton } from 'antd';
import { parse } from 'qs';
import { getBrowserInfo } from '@/utils/utils';
import { useToken } from '@/hooks';
import { connect } from 'react-redux';
import { CopyToClipboard } from 'react-copy-to-clipboard';

function BrowserRedirect(props) {
  const { location, history, setToken, fetchAllInfo } = props;
  const [loading, setLoading] = useState(true);
  const currentToken = useToken();
  const chrome = getBrowserInfo().toString().indexOf('chrome') > -1;
  const { access_token: urlToken } = parse(location.search.replace('?', ''));
  const targetUrl = urlToken
    ? window.location.href
    : `${window.location.href}?access_token=${currentToken}`;

  useEffect(() => {
    if (chrome) {
      redirectOnChrome(urlToken);
    } else {
      redirectOnIE();
    }
  }, []);

  async function redirectOnChrome(token) {
    const path = location.pathname.replace('/browserRedirect', '');
    if (token) {
      setToken(token);
      await fetchAllInfo();
      setLoading(false);
    }
    history.replace({
      pathname: path,
      search: location.search,
    });
  }

  function redirectOnIE() {
    console.log('ie');
    if (window.ActiveXObject !== undefined) {
      console.log('ie2');
      const objShell = new window.ActiveXObject('WScript.Shell');
      objShell.Run(`cmd.exe /c start chrome "${targetUrl}"`, 0, true);
    }
  }

  function handleCopy(text, result) {
    if (result) {
      message.success('复制成功');
    } else {
      message.error('复制失败');
    }
  }

  return (
    <>
      {!chrome ? (
        <Result
          title="已自动帮您跳转到谷歌浏览器"
          subTitle="如果未跳转成功, 可以点击复制网址后, 使用谷歌浏览器打开"
          extra={
            <CopyToClipboard text={targetUrl} onCopy={handleCopy}>
              <Button type="primary" key="console">
                复制网址
              </Button>
            </CopyToClipboard>
          }
        />
      ) : (
        <Skeleton active loading={loading} />
      )}
    </>
  );
}

BrowserRedirect.propTypes = {
  setToken: PropTypes.func.isRequired,
  fetchAllInfo: PropTypes.func.isRequired,
};

BrowserRedirect.defaultProps = {};

const mapDispatchToProps = (dispatch) => ({
  setToken: dispatch.user.setToken,
  fetchAllInfo: dispatch.user.fetchAllInfo,
});

export default connect(null, mapDispatchToProps)(BrowserRedirect);
